import { useEffect, useState } from 'react'
import { connectRange } from 'react-instantsearch-dom'
import { numberWithCommas } from '@utils/helper'
import 'rheostat/initialize'
import Rheostat from 'rheostat'

const RangeSlider = ({
  min,
  max,
  currentRefinement,
  canRefine,
  refine,
}: any) => {
  const [stateMin, setStateMin] = useState(min)
  const [stateMax, setStateMax] = useState(max)

  useEffect(() => {
    if (canRefine) {
      setStateMin(currentRefinement.min)
      setStateMax(currentRefinement.max)
    }
  }, [currentRefinement.min, currentRefinement.max])

  if (min === max) {
    return null
  }

  const onChange = ({ values: [min, max] }: any) => {
    if (currentRefinement.min !== min || currentRefinement.max !== max) {
      refine({ min, max })
    }
  }

  const onValuesUpdated = ({ values: [min, max] }: any) => {
    setStateMin(min)
    setStateMax(max)
  }

  return (
    <>
      <div className="w-full text-center pb-5 text-sm text-black">
        ${numberWithCommas(stateMin)} - ${numberWithCommas(stateMax)}
      </div>
      <Rheostat
        min={min}
        max={max}
        values={[currentRefinement.min, currentRefinement.max]}
        onChange={onChange}
        onValuesUpdated={onValuesUpdated}
      >
        <div className="rheostat-marker left-0">
          <div className="rheostat-value text-xs font-thin">
            ${numberWithCommas(min)}
          </div>
        </div>
        <div className="rheostat-marker right-0">
          <div className="rheostat-value text-xs font-thin">
            ${numberWithCommas(max)}
          </div>
        </div>
      </Rheostat>
    </>
  )
}

const CustomRangeSlider = connectRange(RangeSlider)

export default CustomRangeSlider
